import { render, staticRenderFns } from "./MrQuillEditor.vue?vue&type=template&id=45db4aa4"
import script from "./MrQuillEditor.vue?vue&type=script&lang=js"
export * from "./MrQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./MrQuillEditor.vue?vue&type=style&index=0&id=45db4aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports